// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__edvxi","item":"PaymentsMobile_item__XohIr","label":"PaymentsMobile_label__FWsKS","amount":"PaymentsMobile_amount__15xgp"};